import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from 'Components/Input';
import Checkbox from 'Components/Checkbox';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import { ReactComponent as UploadPlusIcon } from 'Icons/plus-theme.svg';
import { ReactComponent as Truck } from 'Icons/truck.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { ReactComponent as CalcIcon } from 'Icons/accounting.svg';
import Cx from 'classnames';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import {TAT_UNITS, COST_TYPE, ROAD_COASTAL_LEGS, ROAD_RAIL_COASTAL_LEGS, ROAD_RAIL_LEGS, PROVIDER_TYPES } from 'Constants/commonConstants';
import GroupContainer from 'Components/AWLMultiMode/GroupContainer';
import { DateRangePicker } from 'react-dates';
import Moment from 'moment';
import Upload from "Components/Upload";
import { UPLOAD_DOCUMENT, GET_GROUPS_AND_TRANSPORTERS_SUCCESS, CHECK_CONTRACT_EXIST, GET_LPP_DETAILS, GET_YARD_TO_YRAD_CONSTANTS_LIST, CALUCALATE_FREIGHT_RATE, GET_OTHER_LPP_DETAILS, GET_ROUTE_CODE, SAVE_ROUTE_CODE, DOWNLOAD_AWL_MULTIMODE_TEMPLATE, UPLOAD_AWL_MULTIMODE_TRIPS, GET_YARD_LOCATIONS, DOWNLOAD_UPLOADED_FILE } from 'Constants/actionConstants';
import Overlay from 'Components/Overlay';
import Heading from 'Components/Heading';
import Confirmation from 'Components/ConfirmationPopup';
import { getUser } from 'Utils/storage';
import { isCoromandel } from 'Utils/index';
import ClickOutside from 'Components/ClickOutside';
import Autosuggest from 'react-autosuggest';


const getSuggestionValue = suggestion => ( suggestion.branch_name ) ;
const renderSuggestion = suggestion => <span>{suggestion.branch_name}</span>;

const shouldReturnTypeBasedOnLegName = legName => {
    if (legName === 'Port To Port') return 22;
    if (legName === 'Yard To Yard (Container)') return 21;
    return 8;
}

const commodityCategory = [
    { name: 'Sugar', value: 1 },
    { name: 'Edible Oil', value: 2}
]

const wagonType = [
    {name: 'BCNA- BOGIES COVERED AIR BRAKES', value: 1}
]

const loadType = [
    {name: 'Wagon', value: 1 },
    {name: 'Train', value: 2 }
]

const leg_main_fields = {
    legType: '',
    legName: ''
}

const leg_fields = {
    from: {},
    to: {},
    tatValue: '',
    tatUnit: '',
    businessVolumeValue: '',
    businessVolumeUnit: '',
    legBudget: '',
    qbr: '',
    lpp: "0",
    docs: [],
    transporters: [],
    childs: [],
    selectedChilds: ['Transporter', 'Handling Agent', 'Surveyor', 'Lashing']
}

const leg_railway_fields = {
    from: {},
    to: {},
    commodityCategory: '',
    commodityName: '',
    distance: '',
    loadType: '',
    tarrifLines: '',
    wagonType: '',
    freightValue: []
}

const legWithOnlyChilds = ['Plant To Port', 'Port To Depot', 'Plant To Yard', 'Yard To Port', 'Yard To Depot', 'Yard To Party', 'Door To Door', 'Door to Door Container', 'Plant to Destination ICD', 'Destination ICD to Depot', 'Destination ICD to Consignee'];

class AWLMUltiModeAddTrip extends Component {
    constructor(props){
        super(props);
        const legs = [];
        this.legTypes = ROAD_RAIL_COASTAL_LEGS;
        this.state = {
            legs : props.isEdit ? props.tripData : [
                {
                ...JSON.parse(JSON.stringify(leg_main_fields)),
                contractTenureFrom: props.rfq && props.rfq.rfqDetails && props.rfq.rfqDetails.contractTenureFrom || null,
                contractTenureTo: props.rfq && props.rfq.rfqDetails && props.rfq.rfqDetails.contractTenureTo || null,
            }],
            transportLeg: '',
            transportChild: '',
            deleteChidIdx: '',
            deletelegIdx: '',
            isConfirm: false
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({
            type: GET_YARD_TO_YRAD_CONSTANTS_LIST
        })
    }

    setLocation = (type, legIdx, location, skipContractCheck = false) => {
        const { legs } = this.state;
        legs[legIdx][type] = location;
        this.setState({ legs }, () => {
            const legData = legs[legIdx];
            if(['Yard To Yard (Container)', 'Port To Port'].includes(legData.legName) && legData.from.location && legData.to.location) {
                const providerType = (legData.legName === 'Yard To Yard (Container)') ? 8 : 22;
                this.getOtherLPPValue(providerType, legIdx);
            }
        });
        if (!skipContractCheck) {
            this.checkContractExist(false, legIdx);
        }
    }

    checkContractExist = (isChild, legIdx, childIdx, childHCIdx) => {
        const { legs } = this.state;
        const { dispatch } = this.props;
        const tempData = isChild ? legs[legIdx].childs[childIdx] : legs[legIdx];
        const data = {
            from: '',
            to: '',
            providerType: tempData.providerType,
            contractTenureFrom: tempData.contractTenureFrom,
            contractTenureTo: tempData.contractTenureTo
        }
        if(isChild) {
            const childData = tempData.childCharges[childHCIdx];
            data.from = childData.from && (childData.from.city || childData.from.location) || '';
            data.to = tempData.providerType === 2 ? childData.to && (childData.to.city || childData.to.location) || '' : '';
            data.contractTenureFrom = childData.contractTenureFrom || '';
            data.contractTenureTo= childData.contractTenureTo || '';
            if(data.from && (tempData.providerType === 2 ? data.to : true)) {
                dispatch({
                    type: CHECK_CONTRACT_EXIST,
                    data,
                    onSuccess: (data) => {
                        if(data.is_existing_contract) {
                            const contract = data.is_existing_contract_list && data.is_existing_contract_list.length > 0 && data.is_existing_contract_list[0] || {};
                            this.setState({
                                isRouteConfirmation: true,
                                message: `Already Contract Exist For This Route ( ${Moment(contract.contract_tenure_from).format('DD MMM YYYY')} - ${Moment(contract.contract_tenure_to).format('DD MMM YYYY')} ), Still Do You Want To Create A New One?`,
                                deletelegIdx: legIdx,
                                deleteChidIdx: childIdx,
                                childHCIdx
                            })
                        }
                    }
                })
            }
        } else {
            data.from = tempData.from && (tempData.from.city || tempData.from.location) || '';
            data.to = tempData.to && (tempData.to.city || tempData.to.location) || '';
            if(data.from && data.to) {
                dispatch({
                    type: CHECK_CONTRACT_EXIST,
                    data,
                    onSuccess: (data) => {
                        if(data.is_existing_contract) {
                            const contract = data.is_existing_contract_list && data.is_existing_contract_list.length > 0 && data.is_existing_contract_list[0] || {};
                            this.setState({
                                isRouteConfirmation: true,
                                message: `Already Contract Exist For This Route From ${Moment(contract.contract_tenure_from, 'DD MMM YYY')} To ${Moment(contract.contract_tenure_to, 'DD MMM YYY')}, Still Do You Want To Create A New One?`,
                                deletelegIdx: legIdx
                            })
                        }
                    }
                })
            }
        }
    }

    onSelect = (value, name, legIdx, selName) => {
        const { legs, selectedChilds } = this.state;
        const { rfq } = this.props;
        const rfqDetails = rfq && rfq.rfqDetails || {};
        if(legs[legIdx][name] && name === 'legType') {
            legs[legIdx] = JSON.parse(JSON.stringify(leg_main_fields));
            legs[legIdx][name] = value;
        } else {
            legs[legIdx][name] = value;
        }   
        if(name === 'legType') {
            legs[legIdx]['legName'] = selName;
            if(['Port To Port', 'Yard To Yard (Container)'].includes(selName)) {
                legs[legIdx] = {
                    ...legs[legIdx],
                    ...JSON.parse(JSON.stringify(leg_fields)),
                    contractTenureFrom: rfqDetails.contractTenureFrom || null,
                    contractTenureTo: rfqDetails.contractTenureTo || null,
                    providerType: shouldReturnTypeBasedOnLegName(selName),
                    providerName: selName === "Port To Port" ? "Shipping Liners" : "Handling Agent"
                }
            } else if(selName === 'Yard To Yard (BCN)') {
                legs[legIdx] = {
                    ...legs[legIdx],
                    ...JSON.parse(JSON.stringify(leg_railway_fields)),
                    contractTenureFrom: rfqDetails.contractTenureFrom || null,
                    contractTenureTo: rfqDetails.contractTenureTo || null
                }
            }
            if(legWithOnlyChilds.includes(selName)) {
                const oChilds = ((this.legTypes).find(leg => leg['name'] === legs[legIdx]['legName'])) || {};
                legs[legIdx].childs = [];
                ((oChilds.childs || []).filter(child => selectedChilds.includes(child.name)) || []).map(data => (
                    legs[legIdx].childs.push({
                        providerType: data.value,
                        providerName: data.name,
                        remarks: '',
                        docs: [],
                        childCharges: [this.getChildChargesfields(data.name, '' , (legs[legIdx].legName)) || {}],
                        transporters: [],
                        pricing_basis: 6,
                        pricing_basis_name: 'Rate per MT'
                    })
                ))
            } else {
                legs[legIdx].childs = [];
            }
        }
        this.setState({ legs , selectedChilds: '', selectedLeg: '' });
    }

    onChange = (legIdx, e) => {
        const { name, value } = e.target;
        const { legs } = this.state;
        legs[legIdx][name] = value;
        this.setState({ legs });
    }

    addChild = (legIndex) => {
        const { legs } = this.state;
        const { rfq } = this.props;
        // let stopDetails = '';
        // if(legs[legIndex].childs.length > 0) {
        //     stopDetails = legs[legIndex].childs.find(el => el.providerName === 'Transporter');
        // }
        legs[legIndex].childs.push({
            providerType: '',
            providerName: '',
            remarks: '',
            docs: [],
            childCharges: [],
            transporters: [],
            pricing_basis: 6,
            pricing_basis_name: 'Rate per MT'
        });
        this.setState({ legs });
    }

    removeChild = (mainIndex, index) => {
        const { legs } = this.state;
        legs[mainIndex].childs.splice(index, 1);
        this.setState({ legs });
    }

    setChildHeader = (legIndex, index, value, name, selName) => {
        const { legs } = this.state;
        const { rfq } = this.props;
        // const rfqDetails = rfq && rfq.rfqDetails || {};
        legs[legIndex].childs[index][name] = value;
        if(name === 'providerType') {
            legs[legIndex].childs[index]['providerName'] = selName;
            legs[legIndex].childs[index].childCharges = [];
            const cCharges = index > 0 && legs[legIndex].childs[index - 1].childCharges[0] || '';
            legs[legIndex].childs[index].childCharges.push(this.getChildChargesfields(selName, cCharges));
        } else if(name === 'pricing_basis') {
            legs[legIndex].childs[index]['pricing_basis'] = value;
            legs[legIndex].childs[index]['pricing_basis_name'] = selName;
        }
        this.setState({ legs });
    }

    onChildChange = (legIndex, index, hcIndex, value, name, selName,el={}) => {
        const { legs } = this.state;
        if(name === 'vehicle_type') {
            (legs[legIndex].childs || []).forEach(child => {
                if(hcIndex < child.childCharges.length) {
                    child.childCharges[hcIndex]['vehicle_details'][name] = value;
                    child.childCharges[hcIndex]['vehicle_details']['vehicle_type_name'] = selName;
                    child.childCharges[hcIndex]['vehicle_details']['vehicle_capacity'] = el.vehicle_capacity;
                }
            });
        } else if(name === 'vehicle_body_type') {
            (legs[legIndex].childs || []).forEach(child => {
                if(hcIndex < child.childCharges.length) {
                    child.childCharges[hcIndex]['vehicle_details'][name] = value;
                    child.childCharges[hcIndex]['vehicle_details']['vehicle_body_type_name'] = selName;
                }
            });
        } else if(name === 'container_type') {
            (legs[legIndex].childs || []).forEach(child => {
                if(hcIndex < child.childCharges.length) {
                    if(child.childCharges[hcIndex]['container_details']) {
                        child.childCharges[hcIndex]['container_details'][name] = selName;
                        child.childCharges[hcIndex]['container_details']['container_id'] = value;
                    } else {
                        child.childCharges[hcIndex]['container_details'] = {
                            [name]: selName,
                            ['container_id']: value
                        }
                    }  
                    
                }
            });
        } else if(name === 'multi_mode_movement_type_id') {
            // legs[legIndex].childs[index].childCharges[hcIndex][name] = value
            // legs[legIndex].childs[index].childCharges[hcIndex]['multi_mode_movement_type'] = selName;
            (legs[legIndex].childs || []).map(child => (
                // child.childCharges[hcIndex][name] = value;
                // child.childCharges[hcIndex]['multi_mode_movement_type'] = selName;
                (child.childCharges || []).forEach(cCharge => {
                    cCharge[name] = value;
                    cCharge['multi_mode_movement_type'] = selName;
                })
            ));
            if(value !== 4) {
                (legs[legIndex].childs || []).forEach(child => {
                    if([1,2,3].includes(value)) {
                        child.childCharges[hcIndex].container_details = {};
                        delete child.childCharges[hcIndex].vehicle_details.vehicle_body_type;
                        delete child.childCharges[hcIndex].vehicle_details.vehicle_body_type_name;
                    } else if(value === 4 && child.childCharges[hcIndex].hasOwnProperty('container_details')) {
                        delete child.childCharges[hcIndex].container_details
                    }
                });
            }
        }else {
            legs[legIndex].childs[index].childCharges[hcIndex][name] = value;
        }
        this.setState({ legs }, () => {
            const childData = legs[legIndex].childs[index];
            const cCharges = childData.childCharges[hcIndex];
            const vehicleData = cCharges['vehicle_details'];
            if(vehicleData && vehicleData['vehicle_type_name'] && (vehicleData['vehicle_body_type_name'] || (cCharges['container_details'] || {}).container_type)) {
                if(childData.providerName === 'Transporter') {
                    this.getLPPValue(legIndex, index, hcIndex);
                } else {
                    this.getOtherLPPValue(childData.providerType, legIndex, index, hcIndex);
                }
                
            }
        });
    }

    getRouteCode = (legIdx, childIdx, childHCIdx, from, to) => {
        this.props.dispatch({
            type: GET_ROUTE_CODE,
            data: {
                from: (from || '').split(',')[0],
                to: (to || '').split(',')[0]
            },
            onSuccess: (data) => {
                const { legs } = this.state;
                const charges = legs[legIdx].childs[childIdx].childCharges[childHCIdx];
                legs[legIdx].childs[childIdx].childCharges[childHCIdx]['route_code'] = data.route_code;
                // if(!data.route_code) {
                //     legs[legIdx].childs[childIdx].childCharges[childHCIdx]['route_code_not_exist'] = true;
                // } else if(data.route_code && charges.hasOwnProperty('route_code_not_exist')) {
                //     delete legs[legIdx].childs[childIdx].childCharges[childHCIdx]['route_code_not_exist'];
                // }
                this.setState({
                    legs
                })
            }
        })
    }

    onSaveRouteCode = (legIdx, childIdx, hcIdx) => {
        const { legs } = this.state;
        const charges = legs[legIdx].childs[childIdx].childCharges[hcIdx];
        this.props.dispatch({
            type: SAVE_ROUTE_CODE,
            data: {
                from: charges.from_location || ((charges.from || {}).city || (charges.from || {}).location || '').split(',')[0],
                to: charges.to_location || ((charges.to || {}).city || (charges.to || {}).location || '').split(',')[0],
                distance: charges.distance,
                distance_uom: "KM",
                sap_code: charges.route_code,
                company_id: getUser().companyId,
                is_distance_from_google: charges.distance ? false : true
            }
        })
    }

    toggleAllTransporters = (group, index, childIdx, e) => {
        const { legs } = this.state;
        const transDetails = legs[index].childs[childIdx].transporters;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            legs[index].childs[childIdx].transporters.splice(isExist, 1);
        } else {
            legs[index].childs[childIdx].transporters.push(JSON.parse(JSON.stringify(group)));
        }
        this.setState({ legs });
    }

    toggleAllLegTransporters = (group, index, e) => {
        const { legs } = this.state;
        const transDetails = legs[index].transporters;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            legs[index].transporters.splice(isExist, 1);
        } else {
            legs[index].transporters.push(JSON.parse(JSON.stringify(group)));
        }
        this.setState({ legs });
    }

    toggleTransporter = (index, childIdx, transporter, group) => {
        const { legs } = this.state;
        const transGroup = JSON.parse(JSON.stringify(group));
        const transDetails = legs[index].childs[childIdx].transporters;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            const isTransporter = (transDetails[isExist].transporters || []).findIndex(trans => trans.id === transporter.id);
            if(isTransporter > -1) {
                legs[index].childs[childIdx].transporters[isExist].transporters.splice(isTransporter, 1);
            } else {
                legs[index].childs[childIdx].transporters[isExist].transporters.push(JSON.parse(JSON.stringify(transporter)));
            }
        } else {
            transGroup.transporters = [];
            transGroup.transporters.push(transporter)
            legs[index].childs[childIdx].transporters.push(transGroup);
        }
        this.setState({ legs });
    }

    toggleLegTransporter = (index, transporter, group) => {
        const { legs } = this.state;
        const transGroup = JSON.parse(JSON.stringify(group));
        const transDetails = legs[index].transporters;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            const isTransporter = (transDetails[isExist].transporters || []).findIndex(trans => trans.id === transporter.id);
            if(isTransporter > -1) {
                legs[index].transporters[isExist].transporters.splice(isTransporter, 1);
            } else {
                legs[index].transporters[isExist].transporters.push(JSON.parse(JSON.stringify(transporter)));
            }
        } else {
            transGroup.transporters = [];
            transGroup.transporters.push(transporter)
            legs[index].transporters.push(transGroup);
        }
        this.setState({ legs });
    }

    removeLeg = (legIdx) => {
        const { legs } = this.state;
        legs.splice(legIdx, 1);
        this.setState({ legs });
    }

    addLeg = () => {
        const { legs } = this.state;
        const { rfq } = this.props;
        // legs.push({
        //     from: {},
        //     to: {},
        //     legType: '',
        //     legName: '',
        //     tatValue: '',
        //     tatUnit: '',
        //     businessVolumeValue: '',
        //     businessVolumeUnit: '',
        //     legBudget: '',
        //     qbr: '',
        //     lpp: '',
        //     contractTenureFrom: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureFrom || null,
        //     contractTenureTo: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureTo || null,
        //     childs: [],
        //     transporters: []
        // });
        legs.push(JSON.parse(JSON.stringify(leg_main_fields)));
        this.setState({ legs });
    }

    getChildChargesfields = (providerType, charges = {}, legName = '') => {
        const { rfq, plantLocationList, selectedNavBranch } = this.props;
        let data = {
            qbr: '',
            lpp: '0',
            marketRate: '',
            from: (charges || {}).from || (['Plant To Yard', 'Plant To Port'].includes(legName) && providerType === 'Transporter' && (plantLocationList || []).find(plant => plant.branch_id === ((selectedNavBranch || {}).branch_id || getUser().branchId))) || {},
            multi_mode_movement_type: (charges || {}).multi_mode_movement_type || '',
            multi_mode_movement_type_id: (charges || {}).multi_mode_movement_type_id || '',
            contractTenureFrom: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureFrom || null,
            contractTenureTo: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureTo || null,
            vehicle_details: {
                vehicle_type: (charges.vehicle_details || {}).vehicle_type || '',
                vehicle_type_name: (charges.vehicle_details || {}).vehicle_type_name || ''
            }
        }
        if((charges || {}).multi_mode_movement_type_id === 4) {
            data = {
                container_details: charges.container_details || {},
                ...data,
            }
        } else if([1,2,3].includes((charges || {}).multi_mode_movement_type_id)) {
            data.vehicle_details['vehicle_body_type'] = (charges.vehicle_details || {}).vehicle_body_type || '';
            data.vehicle_details['vehicle_body_type_name'] = (charges.vehicle_details || {}).vehicle_body_type_name || '';
        }
        if(providerType === 'Transporter') {
            data = {
                to: {},
                distance: '',
                ...data
            }
        }
        return data;
    }

    addHandlingCharge = (legIndex, index) => {
        const { legs } = this.state;
        const { rfq } = this.props;
        const providerName = legs[legIndex].childs[index].providerName;
        // let data = {
        //     qbr: '',
        //     lpp: '',
        //     marketRate: '',
        //     from: {},
        //     contractTenureFrom: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureFrom || null,
        //     contractTenureTo: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureTo || null
        // }
        // if(legs[legIndex].childs[index].providerName === "Transporter") {
        //     data = {
        //         vehicle_details: {
        //             vehicle_type: '',
        //             vehicle_type_name: '',
        //             vehicle_body_type: '',
        //             vehicle_body_type_name: ''
        //         },
        //         to: {},
        //         distance: '',
        //         ...data
        //     }
        // }
        legs[legIndex].childs[index].childCharges.push(this.getChildChargesfields(providerName));
        this.setState({ legs });
    }

    removeHandlingCharge = (legIndex, index, hcIndex) => {
        const { legs } = this.state;
        legs[legIndex].childs[index].childCharges.splice(hcIndex, 1);
        this.setState({ legs });
    }

    setHCLocation = (name, legIndex, index, hcIndex, location) => {
        const { legs } = this.state;
        if(name === 'from') {
            if(['Port To Depot', 'Yard To Depot', 'Yard To Party'].includes(legs[legIndex].legName)) {
                (legs[legIndex].childs || []).map((child, cIndex) => (
                    // legs[legIndex].childs[cIndex].childCharges[hcIndex][name] = location;
                    (legs[legIndex].childs[cIndex].childCharges || []).map(cCharge => (
                        cCharge[name] = location
                    ))
                ))
            } else {
                legs[legIndex].childs[index].childCharges[hcIndex][name] = location;
            }
        } else {
            if(['Plant To Yard', 'Plant To Port', 'Door To Door'].includes(legs[legIndex].legName)) {
                (legs[legIndex].childs || []).map((child, cIndex) => (
                    // legs[legIndex].childs[cIndex].childCharges[hcIndex][name] = location;
                    (legs[legIndex].childs[cIndex].childCharges || []).forEach(cCharge => {
                        if(legs[legIndex].childs[cIndex].providerName === "Transporter") {
                            cCharge[name] = location;
                        } else {
                            cCharge['from'] = location;
                        }
                        
                    })
                ))
            } else {
                legs[legIndex].childs[index].childCharges[hcIndex][name] = location;
            }
        }
        
        this.setState({ 
            legs, 
            [`showsearchFromText-leg${legIndex}-child${index}-charges${hcIndex}Autosuggest`]: name === 'from' && !location.hasOwnProperty('city') ? true : false,  
            [`showsearchToText-leg${legIndex}-child${index}-charges${hcIndex}Autosuggest`]: name === 'to' && !location.hasOwnProperty('city') ? true : false
        }, () => {
            const childData = legs[legIndex].childs[index];
            if(childData.providerName !== "Transporter") {
                this.getOtherLPPValue(childData.providerType, legIndex, index, hcIndex)
            }
        });
        this.checkContractExist(true, legIndex, index, hcIndex);
        const cCharges = legs[legIndex].childs[index].childCharges[hcIndex];
        if((cCharges.from || {}).location && (cCharges.to || {}).location) {
            this.getRouteCode(legIndex, index, hcIndex, ((cCharges.from || {}).city || (cCharges.from || {}).location), ((cCharges.to || {}).city || (cCharges.to || {}).location));
        }
    }

    isAllFieldsFilled = (leg) => {
        let notFilled = false;
        const excludedFields = [
            'remarks',
            'route_code',
            ...(isCoromandel() ?
                ['businessVolumeValue', 'businessVolumeUnit', 'legBudget', 'qbr'] : [])
            ];
        (Object.keys(leg) || []).forEach(field => {
            if(typeof(leg[field]) === 'object' && !['childs', 'childCharges', 'remarks', 'route_code'].includes(field) && leg[field] && leg[field].length === 0) {
                notFilled = true;
            } else if(!excludedFields.includes(field) && typeof(leg[field]) !== 'object' && !leg[field]) {
                notFilled = true;
            }
        })
        if(isCoromandel() && leg.legName && (!(leg.from || {}).location || !(leg.to || {}).location)) {
            notFilled = true;
        }
        return notFilled;
    }

    validation = () => {
        const { legs } = this.state;
        let isNotFilledAll = false;
        legs.map(leg => {
            if(this.isAllFieldsFilled(leg)) {
                isNotFilledAll = true;
            }
            (leg.childs || []).forEach(child => {
                if(this.isAllFieldsFilled(child)) {
                    isNotFilledAll = true;
                }
                (child.childCharges || []).forEach(hc => {
                    if(this.isAllFieldsFilled(hc)) {
                        isNotFilledAll = true;
                    }
                })
            })
        })
        return isNotFilledAll;
    }

    addTrip = () => {
        const { legs } = this.state;
        if(!this.validation()) {
            this.setState({ isError: false });
            if(this.props.isEdit) {
                this.props.onCancelEdit();
            }
            this.props.addTrip(legs);
        } else {
            this.setState({
                isError: true
            })
        }
    }

    onUploadDocument = (legIndex, childIndex = '', file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            onSuccess: (data) => { 
                const { legs } = this.state;
                if(childIndex === '') {
                    legs[legIndex]['docs'].push(data);
                } else {
                    legs[legIndex].childs[childIndex]['docs'].push(data);
                }
                this.setState({ legs });
            }
         });
    }

    setTransport = (legIdx = '', childTdx = '', type = '') => {

        const { dispatch } = this.props;
        dispatch({
            type: GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
            groups: [],
            transporters: [],
            isMultimode: true
        })

        this.setState({
            transportLeg: legIdx,
            transportChild: childTdx
        }, () => {
            if(type) {
                this.props.searchGroupsAndTransporters('', type, true);
            } 
            // else {
            //     const { dispatch } = this.props;
            //     dispatch({
            //         type: GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
            //         groups: [],
            //         transporters: []
            //     })
            // }
        })
    }

    onConfirm = () => {
        const { deletelegIdx, deleteChidIdx } = this.state;
        if(deleteChidIdx !== '') {
            this.removeChild(deletelegIdx, deleteChidIdx);
        } else {
            this.removeLeg(deletelegIdx);
        }
        this.onCancel();
    }

    onCancel = () => {
        this.setState({
            deleteChidIdx: '',
            deletelegIdx: '',
            isConfirm: false 
        })
    }

    onContractConfirm = () => {
        this.setState({
            isRouteConfirmation: false,
            deleteChidIdx: '',
            deletelegIdx: '',
            childHCIdx: ''
        })
    }

    onContractCancel = () => {
        const { deletelegIdx, deleteChidIdx, childHCIdx } = this.state;
        const legs = JSON.parse(JSON.stringify(this.state.legs));
        const providerName = legs[deletelegIdx].childs[deleteChidIdx].providerName;
        if(deleteChidIdx !== '') {
            legs[deletelegIdx].childs[deleteChidIdx].childCharges.splice(childHCIdx, 1);
            legs[deletelegIdx].childs[deleteChidIdx].childCharges.push(this.getChildChargesfields(providerName));
        } else {
            legs[deletelegIdx].from = {};
            legs[deletelegIdx].to = {};
        }
        this.setState({
            legs,
            isRouteConfirmation: false,
            deleteChidIdx: '',
            deletelegIdx: '',
            childHCIdx: ''
        })
    }

    getLPPValue = (legIdx, childIdx, childHCIdx) => {
        const { dispatch } = this.props;
        const { legs } = this.state;
        const tempData = legs[legIdx].childs[childIdx].childCharges[childHCIdx];
        const user = getUser();
        dispatch({
            type: GET_LPP_DETAILS,
            data: {
                rfqType: {
                        companyId: (user && user.companyId) ? user.companyId : null,
                        source: tempData.from.location,
                        destination: (tempData.to || {}).location,
                        vehicle_type: tempData.vehicle_details.vehicle_type_name,
                        vehicle_Body: tempData.vehicle_details.vehicle_body_type_name
                    }
            },
            onSuccess: ((data)=> {
                if(data.rfqType) {
                    const { legs } = this.state;
                    legs[legIdx].childs[childIdx].childCharges[childHCIdx].lpp = data.rfqType.lpp.toString();
                    if(data.rfqType.distance) {
                        legs[legIdx].childs[childIdx].childCharges[childHCIdx].distance = data.rfqType.distance || ''
                    }
                    this.setState({
                        legs
                    })
                }
            })
        });
    }

    getOtherLPPValue = (providerType, legIdx, childIdx = '', childHCIdx) => {
        const { dispatch } = this.props;
        const { legs } = this.state;
        const tempData = childIdx !== '' ? legs[legIdx].childs[childIdx].childCharges[childHCIdx] : legs[legIdx];
        // const user = getUser();
        const data = {
            // companyId: (user && user.companyId) ? user.companyId : null,
            providerType,
            fromLocation: tempData.from.location
        }

        if(tempData.to) {
            data.toLocation = tempData.to.location;
        }
        
        dispatch({
            type: GET_OTHER_LPP_DETAILS,
            data,
            onSuccess: ((data)=> {
                const { legs } = this.state;
                if(childIdx !== '') {
                    legs[legIdx].childs[childIdx].childCharges[childHCIdx].lpp = data.lpp && data.lpp.toString() || "0";
                } else {
                    legs[legIdx].lpp = data.lpp && data.lpp.toString() || "0";
                }
                this.setState({
                    legs
                })
            })
        });
    }

    onDeleteUploadedFile = (docIdx, legIdx, childIdx = '') => {
        const { legs } = this.state;
        if(childIdx === '') {
            legs[legIdx].docs.splice(docIdx, 1);
        } else {
            legs[legIdx].childs[childIdx].docs.splice(docIdx, 1);
        }
        this.setState({
            legs
        })
    }

    getProviderName = (type) => {
        return (PROVIDER_TYPES.find(pType => pType.value === type) || {}).name;
    }

    getCommodityNames = (category) => {
        const { YardToYardConstants } = this.props;
        const getFilteredNames = (YardToYardConstants.commodity || []).find(val => val.name === category);
        return getFilteredNames && getFilteredNames.commodityNames || [];
    }

    calculateFreight = (legIdx) => {
        const { legs } = this.state;
        const { dispatch } = this.props;
        const legData = legs[legIdx];
        const params = {
            from: legData.location.from || "HALDIA DOCK COMPLEX AND GENERAL- HDCG" || legData.location.from,
            to: legData.location.to || "KHALILABAD- KLD" || legData.location.to,
            wagonType: legData.wagonType || "BCNA- BOGIES COVERED AIR% BRAKES" || legData.wagonType,
            tariffLines: legData.tariffLines || "GA" || legData.tariffLines,
            commodityCategory: legData.commodityCategory || "SUGAR" || legData.commodityCategory,
            commodityName: legData.commodityName || "RAW CANE SUGAR" || legData.commodityName
        }
        dispatch({
            type: CALUCALATE_FREIGHT_RATE,
            params,
            onSuccess: (data) => {
                legs[legIdx]['distance'] = data.fois_data && data.fois_data.distance;
                legs[legIdx]['freightValue'] = data.fois_data && data.fois_data.freight_table || [];
                this.setState({ legs });
            }
        })
    }

    onCancelAddTrip = () => {
        if(this.props.isEdit) {
            this.props.onCancelEdit();
        }
        this.props.hideAddTrip();
    }

    onhideAutosuggest = (type) => {
		this.setState({ [type]: false });
	}

    onUploadTrips = (type, legIndex, childIndex, file) => {
        const { dispatch, rfq } = this.props;
        dispatch({
            type: UPLOAD_AWL_MULTIMODE_TRIPS,
            file,
            params: {
                type: 1,
                rfqType: rfq.type,
                rfqId: rfq.id
            },
            onSuccess: (data) =>{
                if(data.list && data.list.length > 0) {
                    const { legs } = this.state;
                    const listData = data.list[0];
                    legs[legIndex].childs[childIndex].pricing_basis_name = listData.pricing_basis_name;
                    legs[legIndex].childs[childIndex].pricing_basis = listData.pricing_basis;
                    legs[legIndex].childs[childIndex].childCharges = (data.list || []).map(trip => {
                        const data = {
                            ['number_of_vehicle']: trip.number_of_vehicle,
                            ['multi_mode_movement_type']: trip.multi_mode_movement_type,
                            ['multi_mode_movement_type_id']: trip.multi_mode_movement_type_id,
                            from: trip.from,
                            to: trip.to,
                            vehicle_details: trip.vehicle_details,
                            marketRate: trip.marketRate,
                            qbr: trip.qbr,
                            route_code: trip.route_code,
                            from_location: trip.from_location,
                            to_location: trip.to_location,
                            lpp: trip.lpp && trip.lpp.toString() || "0",
                            distance: trip.distance,
                            contractTenureFrom: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureFrom || null,
                            contractTenureTo: rfq && rfq.rfqDetails && rfq.rfqDetails.contractTenureTo || null,
                        }
                        if(trip.container_id) {
                            data.container_details = trip.container_details;
                        }
                        return data;
                    });
                    const isPlantMovement = ['Plant To Yard', 'Plant To Port', 'Door To Door'].includes(legs[legIndex].legName);
                    (legs[legIndex].childs || []).forEach(childCharge => {
                        if(childCharge.providerName !== 'Transporter') {
                            (childCharge.childCharges || []).forEach(cCharge => {
                                if(isPlantMovement) {
                                    cCharge.from = listData.to;
                                } else if(childCharge.providerName !== 'Transporter') {
                                    cCharge.from = listData.from;
                                }
                                cCharge['multi_mode_movement_type'] =  listData.multi_mode_movement_type;
                                cCharge['multi_mode_movement_type_id'] = listData.multi_mode_movement_type_id;
                                cCharge['vehicle_details'] = listData.vehicle_details;
                                if(listData.container_id) {
                                    cCharge.container_details = listData.container_details;
                                }
                            })
                        }
                    })
                    this.setState({ legs });
                }
            }
        })
    }
    
    downloadTemplate = (type) => {
        const { dispatch, rfq } = this.props;
        const params = {
            type: 1,
            rfqType: rfq.type,
            rfqId: rfq.id
        }
        dispatch({
            type: DOWNLOAD_AWL_MULTIMODE_TEMPLATE,
            params,
            onSuccess: (data) => {
                const link = document.createElement('a');
                link.href = data.url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        })
    }

    getYardLocation = (search) => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_YARD_LOCATIONS,
            params: {
                isYard: true,
                companyId: getUser().companyId,
                search
            }
        })
    }
    downloadUploadedFile = (fileName) => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_UPLOADED_FILE,
            param: {
                fileName
            }
        });
    }

    render() {
        const { legs, transportLeg, transportChild, isConfirm, isRouteConfirmation, isError, message, selectedChilds, selectedLeg } = this.state;
        const {
            businessVolumes,
            vehicleTypes,
            vehicleBodyTypes,
            transporters,
            YardToYardConstants,
            multiModalMovementTypes,
            pricingBasis,
            containerTypes,
            depotLocationList,
            plantLocationList,
            yardLocations
        } = this.props;
        return(
            <div>
                <div className="fs-22 fBold tCenter pv-10 ph-10">{this.props.isEdit ? "Edit Trip" : "Add Trip"}</div>
                {legs && (legs || []).map((leg, legIdx) =>{ 
                    console.log('leg1111111:', leg)
                    return(
                <div key={`leg_${legIdx}`} className="border-status-bar br-5 pl-10 pr-10 pt-10 pb-10 mb-20 pr awl-multi-mode">
                    {legs.length > 1 && 
                        <CloseIcon 
                            className="pa t--15 r--15 curP" 
                            onClick={() => {
                                this.setState({
                                    deleteChidIdx: '',
                                    deletelegIdx: legIdx,
                                    isConfirm: true 
                                })
                            }}
                        />}
                    <div>
                    <div className="flex">
                        <div className="header-medium-color fBold fs-20 mb-10 mr-10 mt-10">
                            { this.props.isEdit ? 'Leg' : `Leg ${legIdx + 1}`}
                        </div>
                        <div className="wt-250">
                            <Dropdown
                                items={[...this.legTypes]}
                                selectedItem={this.legTypes.find(val => { return leg.legType === val.value })}
                                name="legType"
                                onSelect={(e) => {
                                    this.setState({
                                        selectedLeg : {
                                            value: e,
                                            legIdx,
                                        },
                                        selectedChilds: ['Transporter', 'Handling Agent', 'Surveyor', 'Lashing']
                                    })
                                }}
                                displayKey="name"
                                className="flex-1 fs-16"
                                label="Select Leg Type"
                                isError={!this.legTypes.find(val => { return leg.legType === val.value }) && isError}
                                // isZIndexMore={true}
                                isPositionChange={true}
                            />
                        </div>
                    </div>
                    {leg.legName && !legWithOnlyChilds.includes(leg.legName) &&
                    <Fragment>
                        <div className="flex flex-between mb-10">
                            <div className="col-2 mr-20 location-from-to">
                                <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">From {(isCoromandel() || leg.legName === 'Yard To Yard (BCN)' || !(leg.legName || '').includes('Yard')) && <span className="error-color">*</span>}</div>
                                {leg.legName === "Yard To Yard (BCN)" ?
                                    <PlacesAutoComplete 
                                        setLocation={this.setLocation.bind(this, 'from', legIdx)} 
                                        value={leg.from && leg.from.location || ''}
                                        placeholder={'Eg. Bangalore'}
                                        inputClassName={(!(leg.from && leg.from.location || '') && isError) ? 'border-error-color' : ''}
                                    /> :
                                    // <Dropdown 
                                    //     items={YardToYardConstants.locations || []}
                                    //     selectedItem={(YardToYardConstants.locations || []).find(val => leg.from.location === val.value )}
                                    //     name="from"
                                    //     onSelect={(e) => this.setLocation('from', legIdx, {location: e.name})}
                                    //     displayKey="name"
                                    //     className="flex-1 fs-14"
                                    //     label="Select"
                                    //     searchEnabled={true}
                                    // />
                                    <>{(leg.legName).includes('Yard') ? 
                                    <Autosuggest
                                        suggestions={yardLocations || []}
                                        onSuggestionsFetchRequested={() => this.getYardLocation(leg.from.location)}
                                        // onSuggestionsClearRequested={this.onClearNetworkSuggestion}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={{
                                            placeholder: "Eg. Bangalore",
                                            value: leg.from.location || '',
                                            className: Cx('react-autosuggest__input', { 'border-error-color': isCoromandel() && !(leg.from || {}).location && isError }),
                                            onChange: (e) => {
                                                this.setLocation('from', legIdx, {location: e.target.value}, true)
                                            }}
                                        }
                                        id={`yardInput_${legIdx}`}
                                        onSuggestionSelected={(event, { suggestion }) => {
                                            this.setLocation('from', legIdx, {location: suggestion.branch_name, ...suggestion})
                                        }
                                        }
                                    /> :
                                    <Fragment>
                                        <Input
                                            name={`searchFromText-leg${legIdx}`}
                                            value={leg.from.location}
                                            onChange={(e) => this.setLocation('from', legIdx, {location: e.name})}
                                            inputClassName={(!(leg.from && leg.from.location || '') && isError) ? 'border-error-color' : ''}
                                        />
                                        {
                                            (leg.from || {}).location && leg.from.location.length > 0 && // searchMatch && searchMatch.length > 0 &&
                                            <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${fromType}Autosuggest`)}>
                                                <div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
                                                    {
                                                        leg.from.location && leg.from.location.length > 0 && plantLocationList.filter((item) => {
                                                            if (!(leg.from || {}).location) {
                                                                return true;
                                                            }
                                                            return item['city'].toLowerCase().includes(fromText.toLowerCase()) || item['state'].toLowerCase().includes(fromText.toLowerCase());
                                                        }).map((item, searchIndex) => {
                                                            return (
                                                                <div
                                                                    key={searchIndex}
                                                                    name={item.city}
                                                                    className={"flex flex-middle pl-16 ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                                                    onClick={() => this.setLocation('from', legIdx, item)}
                                                                >
                                                                    {item.city} {item.state} {item.country}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </ClickOutside>
                                        }
                                    </Fragment>
                                    }</>
                            }
                                {/* {this.viewMode && <Input value={leg.to.location || ''} />} */}
                            </div>
                            <div className="col-2 mr-20 location-from-to">
                                <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">To {(isCoromandel() || leg.legName === 'Yard To Yard (BCN)' || !(leg.legName || '').includes('Yard')) && <span className="error-color">*</span>}</div>
                                {leg.legName !== "Yard To Yard (BCN)" ? 
                                <>{(leg.legName).includes('Yard') ?
                                <Autosuggest
                                        suggestions={yardLocations || []}
                                        onSuggestionsFetchRequested={() => this.getYardLocation(leg.to && leg.to.location || '')}
                                        // onSuggestionsClearRequested={this.onClearNetworkSuggestion}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={{
                                            placeholder: "Eg. Mumbai",
                                            value: leg.to && leg.to.location || '',
                                            className: Cx('react-autosuggest__input', { 'border-error-color': isCoromandel() && !(leg.to || {}).location && isError }),
                                            onChange: (e) => {
                                                this.setLocation('to', legIdx, {location: e.target.value }, true)
                                            }}
                                        }
                                        id={`yardInput_to_${legIdx}`}
                                        onSuggestionSelected={(event, { suggestion }) => {
                                            this.setLocation('to', legIdx, {location: suggestion.branch_name, ...suggestion})
                                        }
                                        }
                                    /> :
                                <PlacesAutoComplete 
                                    setLocation={this.setLocation.bind(this, 'to', legIdx)} 
                                    value={leg.to && leg.to.location || ''} 
                                    placeholder={'Eg. Mumbai'}
                                    inputClassName={(!(leg.to && leg.to.location || '') && isError) ? 'border-error-color' : ''}
                                />} </>:
                                <Dropdown 
                                    items={YardToYardConstants.locations || []}
                                    selectedItem={(YardToYardConstants.locations || []).find(val => leg.to.location === val.value)}
                                    name="to"
                                    onSelect={(e) => this.setLocation('to', legIdx, { location: e.name })}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="Select"
                                    searchEnabled={true}
                                    isError={!(YardToYardConstants.locations || []).find(val => leg.to.location === val.value) && isError}
                                    isPositionChange={true}
                                />
                                }
                            </div>
                            {leg.legName == "Yard To Yard (BCN)" && <div className="wt-100 mr-10">
                                <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">Distance</div>
                                <div className=""><Input value={leg.distance} onChange={this.onChange.bind(this, legIdx)} name="distance" readOnly inputClassName={(!(leg.distance) && isError) ? 'border-error-color' : ''}/></div>
                            </div>}
                        </div>
                    </Fragment>}

                    <div className="flex mb-10 col-1">
                        {leg.legName && !(legWithOnlyChilds.includes(leg.legName)) &&
                        <div className="wt-150 mr-10">
                            <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Leg Type <span className="error-color">*</span></div>
                            <Dropdown
                                items={[...this.legTypes]}
                                selectedItem={this.legTypes.find(val => { return leg.legType === val.value })}
                                name="legType"
                                onSelect={(e) => {
                                    this.setState({
                                        selectedLeg : {
                                            value: e,
                                            legIdx,
                                        },
                                        selectedChilds: ['Transporter', 'Handling Agent', 'Surveyor', 'Lashing']
                                    })
                                }}
                                displayKey="name"
                                className="flex-1 fs-14"
                                label="Select"
                                isError={!this.legTypes.find(val => { return leg.legType === val.value }) && isError}
                                isZIndexMore={true}
                                isPositionChange={true}
                            />
                        </div>}
                        {((!legWithOnlyChilds.includes(leg.legName)) && (leg.legName && leg.legName !== 'Yard To Yard (BCN)')) &&
                        <Fragment>
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">TAT <span className="error-color">*</span></div>
                                {/* <div className="wt-100p mb-30 flex"> */}
                                <div className="flex">
                                    <Input placeholder="" value={leg.tatValue} onChange={this.onChange.bind(this,legIdx)} name="tatValue" className={(!leg.tatValue && isError) ? 'border-error-color' : ''}/>
                                    <Dropdown
                                    items={[...TAT_UNITS]}
                                    selectedItem={TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value })}
                                    name="tatUnit"
                                    onSelect={(el) => this.onSelect(el.value, 'tatUnit', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="Select"
                                    isError={!TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value }) && isError}
                                    isZIndexMore={true}
                                />
                                </div>
                            </div>
                            <div className="wt-100 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Business Vol {!isCoromandel() && <span className="error-color">*</span>}</div>
                                <div className=""><Input placeholder="" value={leg.businessVolumeValue} onChange={this.onChange.bind(this, legIdx)} name="businessVolumeValue" inputClassName={(!leg.businessVolumeValue && isError && !isCoromandel()) ? 'border-error-color' : ''}/></div>
                            </div>

                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">UOM {!isCoromandel() && <span className="error-color">*</span>}</div>
                                <Dropdown
                                    items={businessVolumes}
                                    selectedItem={businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value })}
                                    name="businessVolumeUnit"
                                    onSelect={(el) => this.onSelect(el.value, 'businessVolumeUnit', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isError={!businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value }) && isError && !isCoromandel()}
                                    isPositionChange={true}
                                />
                            </div>

                            <div className="wt-120 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Budget {!isCoromandel() && <span className="error-color">*</span>}</div>
                                <div className=""><Input placeholder="" value={leg.legBudget} onChange={this.onChange.bind(this, legIdx)} name="legBudget" inputClassName={(!leg.legBudget && isError && !isCoromandel()) ? 'border-error-color' : ''}/></div>
                            </div>

                            <div className="wt-120 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">LPP</div>
                                <div className=""><Input placeholder="" value={leg.lpp} onChange={this.onChange.bind(this, legIdx)} name="lpp" readOnly inputClassName={(!leg.lpp && isError) ? 'border-error-color' : ''}/></div>
                            </div>

                            <div className="wt-120 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Ceiling Price {!isCoromandel() && <span className="error-color">*</span>}</div>
                                <div className=""><Input placeholder="" value={leg.qbr} onChange={this.onChange.bind(this, legIdx)} name="qbr" inputClassName={(!leg.qbr && isError && !isCoromandel()) ? 'border-error-color' : ''}/></div>
                            </div>

                            <div className="wt-200 mr-10 awl_hc_date">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Contract Tenure</div>
                                <DateRangePicker
                                    startDate={leg.contractTenureFrom ? Moment(leg.contractTenureFrom) : null}
                                    startDateId="startDate"
                                    endDate={leg.contractTenureTo ? Moment(leg.contractTenureTo) : null}
                                    endDateId="endDate"
                                    onDatesChange={({ startDate, endDate }) => {
                                        const { legs } = this.state;
                                        const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0);
                                        legs[legIdx]['contractTenureFrom'] = startDateTime;
                                        const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                        legs[legIdx]['contractTenureTo'] = endTime ? new Date(endTime).getTime() : legs[legIdx]['contractTenureTo'];
                                        this.setState({
                                            legs
                                        }, () => {
                                            this.checkContractExist(false, legIdx);
                                        })
                                    }}
                                    focusedInput={this.state[`focusedInput_leg_${legIdx}`]}
                                    onFocusChange={focusedInput => this.setState({ [`focusedInput_leg_${legIdx}`]: true ? focusedInput : null })}
                                    displayFormat={'DD MMM YYYY'}
                                    noBorder={true}
                                    minimumNights={0}
                                />
                            </div>
                        </Fragment>}
                        {leg.legName === 'Yard To Yard (BCN)' &&
                        <Fragment>
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Commodity Category</div>
                                <Dropdown
                                    items={YardToYardConstants.commodity || []}
                                    selectedItem={(YardToYardConstants.commodity || []).find(cc => { return leg.commodityCategory === cc.name })}
                                    name="commodityCategory"
                                    onSelect={(el) => this.onSelect(el.value, 'commodityCategory', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isPositionChange={true}
                                />
                            </div>
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Commodity Name</div>
                                <Dropdown
                                    items={leg.commodityCategory && this.getCommodityNames(leg.commodityCategory) || []}
                                    selectedItem={(this.getCommodityNames(leg.commodityCategory) || []).find(cc => { return leg.commodityName === cc.name })}
                                    name="commodityName"
                                    onSelect={(el) => this.onSelect(el.value, 'commodityName', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isPositionChange={true}
                                />
                            </div>

                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Tarrif Lines</div>
                                <Dropdown
                                    items={YardToYardConstants.tariffLines || []}
                                    selectedItem={(YardToYardConstants.tariffLines || []).find(tt => { return leg.tarrifLines === tt.value })}
                                    name="tarrifLines"
                                    onSelect={(el) => this.onSelect(el.value, 'tarrifLines', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isPositionChange={true}
                                />
                            </div>

                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Load Type</div>
                                <Dropdown
                                    items={loadType}
                                    selectedItem={loadType.find(tt => { return leg.loadType === tt.value })}
                                    name="loadType"
                                    onSelect={(el) => this.onSelect(el.value, 'loadType', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isPositionChange={true}
                                />
                            </div>
                            
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Wagon Type</div>
                                <Dropdown
                                    items={YardToYardConstants.wagonType || []}
                                    selectedItem={(YardToYardConstants.wagonType || []).find(wt => { return leg.wagonType === wt.value })}
                                    name="wagonType"
                                    onSelect={(el) => this.onSelect(el.value, 'wagonType', legIdx)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                    isPositionChange={true}
                                />
                            </div>
                            <div className="wt-200 mr-10 awl_hc_date">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Contract Tenure</div>
                                <DateRangePicker
                                    startDate={leg.contractTenureFrom ? Moment(leg.contractTenureFrom) : null}
                                    startDateId="startDate"
                                    endDate={leg.contractTenureTo ? Moment(leg.contractTenureTo) : null}
                                    endDateId="endDate"
                                    onDatesChange={({ startDate, endDate }) => {
                                        const { legs } = this.state;
                                        const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0);
                                        legs[legIdx]['contractTenureFrom'] = startDateTime;
                                        const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                        legs[legIdx]['contractTenureTo'] = endTime ? new Date(endTime).getTime() : legs[legIdx]['contractTenureTo'];
                                        this.setState({
                                            legs
                                        }, () => {
                                            this.checkContractExist(false, legIdx);
                                        })
                                    }}
                                    focusedInput={this.state[`focusedInput_leg_${legIdx}`]}
                                    onFocusChange={focusedInput => this.setState({ [`focusedInput_leg_${legIdx}`]: true ? focusedInput : null })}
                                    displayFormat={'DD MMM YYYY'}
                                    noBorder={true}
                                    minimumNights={0}
                                />
                            </div>
                            <CalcIcon className="wt-30 ht-30 mt-25 curP" onClick={() => this.calculateFreight(legIdx)}/>
                        </Fragment>}
                    </div>

                    {leg.legName && ['Port To Port', 'Yard To Yard (Container)'].includes(leg.legName) &&
                        <Fragment>
                            <div className="flex">
                                <button className={Cx("b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20 flex-end", {'border-error-color': (leg.transporters || []).length === 0 && isError })} onClick={() => this.setTransport(legIdx, '' , shouldReturnTypeBasedOnLegName(leg.legName))}>Add Provider <span className="error-color">*</span></button>
                                <Upload onChange={this.onUploadDocument.bind(this, legIdx, '')} value="Upload File" accept=".pdf">
                                    <button className={Cx("flex flex-middle flex-center border-theme ht-40 bg-white theme-color fBold fs-16 br-20 ml-10 pl-15 pr-15", {'border-error-color': (leg.docs || []).length === 0 && isError })}>
                                    <UploadPlusIcon className="mr-10"/>Upload T & C <span className="error-color">*</span></button>
                                </Upload>   
                                {leg.docs && leg.docs.length > 0 &&
                                    <div className="ml-10 mt-10 fBold theme-color">
                                       {(leg.docs || []).map((doc, docIdx) => 
                                           <div className="flex mb-5" key={`leg_doc_${docIdx}`}>
                                               <p className='curP'
                                                //    href={doc.url}
                                                    onClick={() => this.downloadUploadedFile(doc.name)}
                                               >
                                                   {doc.name}
                                               </p>
                                               <DeleteIcon className="ht-15 wt-15 ml-5 curP" onClick={() => this.onDeleteUploadedFile(docIdx, legIdx)} />
                                           </div>
                                    )}
                                    </div>
                                }
                                {/* <Truck className="wt-40 ht-40 curP ml-10" onClick={() => this.setTransport(legIdx, '' , leg.legName === 'Port To Port' ? 22 : 8)} /> */}
                            </div>
                            {transportLeg === legIdx && transportChild === '' && <Overlay>
                                <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                                    <Heading 
                                        text={leg.legName === 'Port To Port' ? 'Shipping Liners' : 'Handling Agents'} 
                                        className="tCenter"/>
                                    <CancelIcon onClick={this.setTransport} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" />
                                </div>
                                <div className="flex pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto min-wt-250 max-wt-900 max-ht-700">
                                    {(transporters || []).map(transGroup => (
                                        <div className="mr-10 wt-250">
                                            <GroupContainer
                                                group={transGroup}
                                                toggleAllTransporters={this.toggleAllLegTransporters.bind(this, transGroup, legIdx)}
                                                toggleTransporter={this.toggleLegTransporter.bind(this, legIdx)}
                                                selectedTransporters={leg.transporters || []}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="z-100 box-shadow pl-40 pv-10 pf b-0 col-1 bg-white">
                                <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.setTransport}>Save</button>
                                    <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.setTransport}>Cancel</button>
                                </div>
                            </Overlay>}
                            {leg.transporters.length > 0 && 
                            <div className="pb-5 box-shadow mb-10 mr-10">
                                <div className="bg-theme-light pv-10 fs-16 fSemibold mt-10 mb-10 tCenter">
                                    {leg.legName === 'Port To Port' ? 'Shipping Liners' : 'Handling Agents'} 
                                </div>
                                {leg.transporters.map(transGroup => (
                                    (transGroup.transporters || []).map(transporter => (
                                        <div className="fSemibold fs-16 mb-10 col-3 inBlock pb-10 border-bottom-light-2 tCenter">{transporter.name}</div>
                                    ))
                                ))}
                            </div>}
                        </Fragment>
                    }
                    
                    {leg.legType && leg.legName === 'Yard To Yard (BCN)' && leg.freightValue.length > 0 &&
                    // this.props.rfq.rfqDetails.serviceModes[0] === 9 &&
                    <div className="courier-table mb-10">
                        <table cellpadding="0" cellspacing="0" className="col-1">
                            <thead>
                                <tr>
                                    <th></th>
                                    {leg.freightValue.map(val => <th>{val['Charge Name']}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>Wagon Load</th>
                                    {leg.freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Wagon Load']}</td>)}
                                </tr>
                                <tr>
                                    <th>Train Load</th>
                                    {leg.freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Train Load']}</td>)}
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    {leg.childs && leg.childs.map((childleg, childIdx) => (
                        <div key={`child_${childIdx}`} className={Cx("border-status-bar br-5 pl-10 pt-10 pb-10 mb-20 pr", {'overflowAuto': childleg.providerName === 'Transporter'})}>
                            {!this.props.isEdit && <CloseIcon 
                                className="pa r-0 t--2 curP" 
                                onClick={() => {
                                    this.setState({
                                        deleteChidIdx: childIdx,
                                        deletelegIdx: legIdx,
                                        isConfirm: true 
                                    })
                                }} 
                            />}
                        <Fragment>
                            <div className={'flex mb-10'}>
                                <div className="header-medium-color fBold fs-20 pt-10">{this.props.isEdit ? 'Child' : `Child ${childIdx + 1}`}</div>
                                <div className={Cx("wt-250 ml-20 mr-10")}>
                                    <Dropdown
                                        items={this.legTypes.find(val => { return leg.legType === val.value }).childs}
                                        selectedItem={(this.legTypes.find(val => { return leg.legType === val.value }).childs || []).find(tType => { return childleg.providerName === tType.name })}
                                        name="providerType"
                                        onSelect={(e) => this.setChildHeader(legIdx, childIdx, e.value, 'providerType', e.name)}
                                        displayKey={['Plant To Port', 'Plant To Yard', 'Yard To Depot', 'Port To Depot', 'Yard To Party'].includes(leg.legName) ? "name2" : "name"}
                                        className={Cx("flex-1 fs-14", {
                                            'disabled': childleg.providerName
                                        })}
                                        label="Service Providers"
                                        isError={!(this.legTypes.find(val => { return leg.legType === val.value }).childs || []).find(tType => { return childleg.providerName === tType.name }) && isError}
                                        isPositionChange={true}
                                    />
                                 </div>
                                <div className="wt-250 mr-10">
                                    <div className="wt-100p mr-20">
                                        <Input placeholder="Internal Remarks" value={childleg.remarks}
                                    onChange={(e) => this.setChildHeader(legIdx, childIdx, e.target.value, e.target.name)} name="remarks" />
                                    </div>
                                </div>
                                <div className="wt-250 mr-10">
                                    <Dropdown
                                        items={pricingBasis}
                                        selectedItem={pricingBasis.find(tType => { return childleg.pricing_basis === tType.value })}
                                        name="pricing_basis"
                                        onSelect={(e) => this.setChildHeader(legIdx, childIdx, e.value, 'pricing_basis', e.name)}
                                        displayKey="name"
                                        className="flex-1 fs-14"
                                        label="Pricing Basis"
                                        isError={!pricingBasis.find(tType => { return childleg.pricing_basis === tType.value }) && isError}
                                        isPositionChange={true}
                                    />
                                 </div>
                               {childleg.providerName === 'Transporter' && ['Port To Depot', 'Yard To Depot', 'Yard To Party'].includes(leg.legName) && 
                                <>
                                    <button className={"b-20 ht-30 br-20 white-color bg-theme fs-14 fBold pl-30 pr-30 flex-end"} onClick={() => this.downloadTemplate(leg.legType)}>Download Template</button>
                                    <Upload onChange={this.onUploadTrips.bind(this, leg.legType, legIdx, childIdx)} value="Upload File">
                                        <button className={"flex flex-middle flex-center border-theme ht-30 bg-white theme-color fBold fs-14 br-20 ml-10 pl-15 pr-15"}>
                                        Upload Excel</button>
                                    </Upload>
                                </>
                                }
                            </div>
                            {childleg.childCharges && (childleg.childCharges || []).map((hc, hcIdx) => (
                                <Fragment>
                                {childleg.providerName && <div key={`child_hc_${childIdx}_${hcIdx}`} className="flex wt-max-content mb-10">
                                    <div className="wt-150 mr-10 pr mb-5">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">
                                            {childleg.providerName === 'Transporter' ? (['Port To Depot', 'Yard To Depot', 'Yard To Party'].includes(leg.legName) ? 'VIA' : 'Origin') : 'Location'}
                                        </div>}
                                        {['Plant To Yard', 'Plant To Port', 'Door To Door'].includes(leg.legName) ? 
                                        <>{((leg.legName).includes('Yard') && childleg.providerName !== 'Transporter') ?
                                        <Autosuggest
                                            suggestions={yardLocations || []}
                                            onSuggestionsFetchRequested={() => this.getYardLocation(hc.from && hc.from.location || '')}
                                            // onSuggestionsClearRequested={this.onClearNetworkSuggestion}
                                            getSuggestionValue={getSuggestionValue}
                                            renderSuggestion={renderSuggestion}
                                            inputProps={{
                                                placeholder: "Eg. Bangalore",
                                                value: hc.from && hc.from.location || '',
                                                onChange: (e) => {
                                                    this.setHCLocation('from', legIdx, childIdx, hcIdx, {location: e.target.value})
                                                }}
                                            }
                                            className={'fBols fs-16'}
                                            id={`yardInput_from_${legIdx}_${childIdx}_${hcIdx}`}
                                            onSuggestionSelected={(event, { suggestion }) => {
                                                this.setHCLocation('from', legIdx, childIdx, hcIdx, {location: suggestion.branch_name, ...suggestion})
                                            }
                                            }
                                        /> :
                                        <Fragment>
                                            <Input
                                                name={`searchFromText-leg${legIdx}-child${childIdx}-charges${hcIdx}`}
                                                value={hc.from && hc.from.location || ''}
                                                placeholder={'Eg. Bangalore'}
                                                onChange={(e) => this.setHCLocation('from', legIdx, childIdx, hcIdx, {location: e.target.value})}
                                                inputClassName={(!(hc.from && hc.from.location || '') && isError) ? 'border-error-color' : ''}
                                            />
                                            {
                                                this.state[`showsearchFromText-leg${legIdx}-child${childIdx}-charges${hcIdx}Autosuggest`] && (hc.from || {}).location && hc.from.location.length > 0 && // searchMatch && searchMatch.length > 0 &&
                                                <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`showsearchFromText-leg${legIdx}-child${childIdx}-charges${hcIdx}Autosuggest`)}>
                                                    <div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
                                                        {
                                                            hc.from.location && hc.from.location.length > 0 && plantLocationList.filter((item) => {
                                                                if (!(hc.from || {}).location) {
                                                                    return true;
                                                                }
                                                                return item['city'].toLowerCase().includes((hc.from || {}).location.toLowerCase()) || (item['state'] || '').toLowerCase().includes((hc.from || {}).location.toLowerCase());
                                                            }).map((item, searchIndex) => {
                                                                return (
                                                                    <div
                                                                        key={searchIndex}
                                                                        name={item.city}
                                                                        className={"flex flex-middle pl-16 max-ht-30 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                                                        onClick={() => this.setHCLocation('from', legIdx, childIdx, hcIdx, item)}
                                                                    >
                                                                        {`${item.city}, ${item.state}, ${item.country}`}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </ClickOutside>
                                            }
                                        </Fragment>}</>
                                        : 
                                        <>{(['Yard To Depot', 'Yard To Party', 'Yard To Port'].includes(leg.legName) && (childleg.providerName === 'Transporter' || leg.legName === 'Yard To Depot')) ?
                                            <Autosuggest
                                                suggestions={yardLocations || []}
                                                onSuggestionsFetchRequested={() => this.getYardLocation(hc.from && hc.from.location || '')}
                                                // onSuggestionsClearRequested={this.onClearNetworkSuggestion}
                                                getSuggestionValue={getSuggestionValue}
                                                renderSuggestion={renderSuggestion}
                                                inputProps={{
                                                    placeholder: "Eg. Bangalore",
                                                    value: hc.from && hc.from.location || '',
                                                    onChange: (e) => {
                                                        this.setHCLocation('from', legIdx, childIdx, hcIdx, {location: e.target.value})
                                                    }}
                                                }
                                                className={'fBols fs-16'}
                                                id={`yardInput_from_${legIdx}_${childIdx}_${hcIdx}`}
                                                onSuggestionSelected={(event, { suggestion }) => {
                                                    this.setHCLocation('from', legIdx, childIdx, hcIdx, {location: suggestion.branch_name, ...suggestion})
                                                }
                                                }
                                            />  :
                                            <>
                                            <PlacesAutoComplete 
                                            setLocation={this.setHCLocation.bind(this, 'from', legIdx, childIdx, hcIdx,)} 
                                            value={hc.from && hc.from.location || ''} 
                                            placeholder={'Eg. Bangalore'}
                                            inputClassName={(!(hc.from && hc.from.location || '') && isError) ? 'border-error-color' : ''}
                                        /></>}
                                        </>}
                                    </div>
                                    {childleg.providerName === 'Transporter' && 
                                    <Fragment>
                                        <div className="wt-150 mr-10 pr mb-5">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{['Port To Depot', 'Yard To Depot'].includes(leg.legName) ? 'Depot' : (['Yard To Party'].includes(leg.legName) ? 'Destination' : 'VIA')}</div>}
                                            {['Yard To Depot', 'Port To Depot', 'Yard To Party'].includes(leg.legName) ? 
                                            <Fragment>
                                            <Input
                                                name={`searchToText-leg${legIdx}-child${childIdx}-charges${hcIdx}`}
                                                value={hc.to && hc.to.location || ''}
                                                placeholder={'Eg. Mangalore'}
                                                onChange={(e) => {
                                                    this.setHCLocation('to', legIdx, childIdx, hcIdx, {location: e.target.value})
                                                }
                                                }
                                                inputClassName={(!(hc.to && hc.to.location || '') && isError) ? 'border-error-color' : ''}
                                            />
                                            {
                                                this.state[`showsearchToText-leg${legIdx}-child${childIdx}-charges${hcIdx}Autosuggest`] && (hc.to || {}).location && hc.to.location.length > 0 && // searchMatch && searchMatch.length > 0 &&
                                                <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`showsearchToText-leg${legIdx}-child${childIdx}-charges${hcIdx}Autosuggest`)}>
                                                    <div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
                                                        {
                                                            hc.to.location && hc.to.location.length > 0 && depotLocationList.filter((item) => {
                                                                if (!(hc.to || {}).location) {
                                                                    return true;
                                                                }
                                                                return (item['city'] || '').toLowerCase().includes((hc.to || {}).location.toLowerCase()) || (item['state'] || '').toLowerCase().includes((hc.to || {}).location.toLowerCase());
                                                            }).map((item, searchIndex) => {
                                                                return (
                                                                    <div
                                                                        key={searchIndex}
                                                                        name={item.city}
                                                                        className={"flex flex-middle pl-16 max-ht-30 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                                                        onClick={() => this.setHCLocation('to', legIdx, childIdx, hcIdx, item)}
                                                                    >
                                                                        {`${item.city}, ${item.state}, ${item.country}`}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </ClickOutside>
                                            }
                                        </Fragment>:
                                        <>{(leg.legName).includes('Yard') && !['Yard To Depot', 'Yard To Party', 'Yard To Port'].includes(leg.legName) ?
                                        <Autosuggest
                                            suggestions={yardLocations || []}
                                            onSuggestionsFetchRequested={() => this.getYardLocation(hc.to && hc.to.location || '')}
                                            // onSuggestionsClearRequested={this.onClearNetworkSuggestion}
                                            getSuggestionValue={getSuggestionValue}
                                            renderSuggestion={renderSuggestion}
                                            inputProps={{
                                                placeholder: "Eg. Mumbai",
                                                value: hc.to && hc.to.location || '',
                                                onChange: (e) => {
                                                    this.setHCLocation('to', legIdx, childIdx, hcIdx, {location: e.target.value})
                                                }}
                                            }
                                            className={'fBols fs-16'}
                                            id={`yardInput_to_${legIdx}_${childIdx}_${hcIdx}`}
                                            onSuggestionSelected={(event, { suggestion }) => {
                                                this.setHCLocation('to', legIdx, childIdx, hcIdx, {location: suggestion.branch_name, ...suggestion})
                                            }
                                            }
                                        />
                                        :
                                            <PlacesAutoComplete 
                                                setLocation={this.setHCLocation.bind(this, 'to', legIdx, childIdx, hcIdx,)} 
                                                value={hc.to && hc.to.location || ''} 
                                                placeholder={'Eg. Mumbai'}
                                                inputClassName={(!(hc.to && hc.to.location || '') && isError) ? 'border-error-color' : ''}
                                            />}</>}
                                        </div>
                                    </Fragment>}
                                        <div className="wt-120 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Movement Type</div>}
                                            <Dropdown
                                                items={multiModalMovementTypes}
                                                selectedItem={multiModalMovementTypes.find(tt => { return hc.multi_mode_movement_type_id === tt.id })}
                                                name="multi_mode_movement_type_id"
                                                onSelect={(el) => this.onChildChange(legIdx, childIdx, hcIdx, el.id, 'multi_mode_movement_type_id', el.name)}
                                                displayKey="name"
                                                className="flex-1 fs-14"
                                                label="Select"
                                                isError={!multiModalMovementTypes.find(tt => { return hc.multi_mode_movement_type_id === tt.id }) && isError}
                                                isPositionChange={true}
                                            />
                                        </div>
                                    {childleg.providerName === 'Transporter' &&<Fragment>
                                        <div className="wt-300 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Vehicle Type</div>}
                                            <Dropdown
                                                items={vehicleTypes}
                                                selectedItem={vehicleTypes.find(vt => { return hc.vehicle_details.vehicle_type === vt.value })}
                                                name="vehicleType"
                                                onSelect={(el) => this.onChildChange(legIdx, childIdx, hcIdx, el.value, 'vehicle_type', el.name,el)}
                                                displayKey={"name"}
                                                className="flex-1 fs-14"
                                                label="Select"
                                                searchEnabled={true}
                                                isError={!vehicleTypes.find(vt => { return hc.vehicle_details.vehicle_type === vt.value }) && isError}
                                                isPositionChange={true}
                                            />
                                        </div>
                                        {[4].includes(hc.multi_mode_movement_type_id) && <div className="wt-200 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Vehicle Body</div>}
                                            <Dropdown
                                                items={vehicleBodyTypes}
                                                selectedItem={vehicleBodyTypes.find(tt => { return hc.vehicle_details.vehicle_body_type === tt.value })}
                                                name="vehicleBodyType"
                                                onSelect={(el) => this.onChildChange(legIdx, childIdx, hcIdx, el.value, 'vehicle_body_type', el.name)}
                                                displayKey="name"
                                                className="flex-1 fs-14"
                                                label="Select"
                                                isError={!vehicleBodyTypes.find(tt => { return hc.vehicle_details.vehicle_body_type === tt.value }) && isError}
                                                isPositionChange={true}
                                            />
                                        </div>}
                                        <div className="wt-100 mr-10">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">No. of Trucks</div>}
                                            <Input type="number" placeholder="Eg. 1" value={hc.number_of_vehicle} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="number_of_vehicle" inputClassName={(isError && !(hc.number_of_vehicle)) ? 'border-error-color' : ''}/>
                                        </div>
                                        {[1,2,3].includes(hc.multi_mode_movement_type_id) && <div className="wt-250 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Container Type</div>}
                                            <Dropdown
                                                items={containerTypes}
                                                selectedItem={containerTypes.find(tt => { return (hc.container_details || {}).container_id === tt.id })}
                                                name="container_type"
                                                onSelect={(el) => this.onChildChange(legIdx, childIdx, hcIdx, el.id, 'container_type', el.name)}
                                                displayKey="name"
                                                className="flex-1 fs-14"
                                                label="Select"
                                                isError={!containerTypes.find(tt => { return (hc.container_details || {}).container_id === tt.id }) && isError}
                                                isPositionChange={true}
                                            />
                                        </div>}
                                    </Fragment>}
                                    {childleg.providerName === 'Transporter' && <>
                                        <div className="wt-80 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Kms</div>}
                                            <Input placeholder="" value={hc.distance} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="distance" inputClassName={(isError && !(hc.distance)) ? 'border-error-color' : ''}/>
                                        </div>
                                        {/* <div className="wt-100 mr-10">
                                            {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Route Code</div>}
                                            <Input placeholder="" value={hc.route_code} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="route_code" onBlur={(e) => { if(e.target.value.length > 5) this.onSaveRouteCode(legIdx, childIdx, hcIdx) }} inputClassName={(isError && !(hc.route_code)) ? 'border-error-color' : ''}/>
                                        </div> */}
                                    </>}
                                    {childleg.providerName !== 'Transporter' && <div className="wt-120 mr-10">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">No. of Man Power Per Shift</div>}
                                        <Input type="number" placeholder="" value={hc.noOfManPower} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="noOfManPower" inputClassName={(isError && !(hc.noOfManPower)) ? 'border-error-color' : ''}/>
                                    </div>}
                                    <div className="wt-80 mr-10">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">MR</div>}
                                        <Input type="number" placeholder="" value={hc.marketRate} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="marketRate" inputClassName={(isError && !(hc.marketRate)) ? 'border-error-color' : ''}/>
                                    </div>

                                    <div className="wt-80 mr-10">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">LPP</div>}
                                        <Input type="number" placeholder="" value={hc.lpp} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="lpp" readOnly inputClassName={(isError && !(hc.lpp)) ? 'border-error-color' : ''}/>
                                    </div>

                                    <div className="wt-80 mr-10">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Ceiling Price</div>}
                                        <Input type="number" placeholder="" value={hc.qbr} onChange={(e) => this.onChildChange(legIdx, childIdx, hcIdx, e.target.value, e.target.name)} name="qbr" inputClassName={(isError && !(hc.qbr)) ? 'border-error-color' : ''}/>
                                    </div>

                                    <div className="wt-200 mr-10 awl_hc_date">
                                        {hcIdx === 0 && <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Contract Tenure</div>}
                                        <DateRangePicker
                                            startDate={hc.contractTenureFrom ? Moment(hc.contractTenureFrom) : null}
                                            startDateId="startDate"
                                            endDate={hc.contractTenureTo ? Moment(hc.contractTenureTo) : null}
                                            endDateId="endDate"
                                            onDatesChange={({ startDate, endDate }) => {
                                                const { legs } = this.state;
                                                const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0);
                                                legs[legIdx].childs[childIdx].childCharges[hcIdx]['contractTenureFrom'] = startDateTime;
                                                const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                                legs[legIdx].childs[childIdx].childCharges[hcIdx]['contractTenureTo'] = endTime ? new Date(endTime).getTime() : legs[legIdx].childs[childIdx].childCharges[hcIdx]['contractTenureTo'];
                                                this.setState({
                                                    legs
                                                }, () => {
                                                    this.checkContractExist(true, legIdx, childIdx, hcIdx);
                                                })
                                            }}
                                            focusedInput={this.state[`focusedInput${childIdx}${hcIdx}`]}
                                            onFocusChange={focusedInput => this.setState({ [`focusedInput${childIdx}${hcIdx}`]: true ? focusedInput : null })}
                                            displayFormat={'DD MMM YYYY'}
                                            noBorder={true}
                                            minimumNights={0}
                                        />
                                    </div>

                                    {['Port To Depot', 'Yard To Depot', 'Yard To Party'].includes(leg.legName) && 
                                    <div className={Cx("wt-60 flex", {
                                        'mt-25' : hcIdx === 0
                                        })}>
                                        {
                                        childleg.childCharges.length > 1 ? <div className="flex flex-middle flex-center wt-25 ht-25 br-20 border-none br-50p mr-5">
                                            <CloseIcon onClick={() => this.removeHandlingCharge(legIdx, childIdx, hcIdx)} className="wt-28 white-color ht-28 pa curP mt-10" />
                                        </div> : ''
                                        }
                                        {
                                        hcIdx == childleg.childCharges.length - 1 && !this.props.isEdit ? <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mt-5">
                                            <PlusIcon onClick={() => this.addHandlingCharge(legIdx, childIdx)} className="wt-15 ht-15" />
                                        </div> : ''
                                        }
                                    </div>}
                                    </div>}
                                    {childleg.providerName && (childleg.childCharges.length -1) === hcIdx &&
                                        <div className="flex mt-10">
                                        <button className={Cx("b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20 flex-end", {'border-error-color': (isError && (childleg.transporters || []).length === 0)})} onClick={() => this.setTransport(legIdx, childIdx, childleg.providerType)}>Add Provider</button>
                                        <Upload onChange={this.onUploadDocument.bind(this, legIdx, childIdx)} value="Upload File" accept=".pdf">
                                            <button className={Cx("flex flex-middle flex-center border-theme ht-40 bg-white theme-color fBold fs-16 br-20 ml-10 pl-15 pr-15", {'border-error-color': (isError && (childleg.docs || []).length === 0)})}>
                                            <UploadPlusIcon className="mr-10"/>Upload T & C</button>
                                        </Upload>   
                                        {childleg.docs && childleg.docs.length > 0 &&
                                            <div className="ml-10 mt-10 fBold theme-color">
                                               {(childleg.docs || []).map((doc, docIdx) => 
                                               <div className="flex mb-5" key={`childs_doc_${docIdx}`}>
                                                    <a href={doc.url} download>{doc.name}</a>
                                                    <DeleteIcon className="ht-15 wt-15 ml-5 curP" onClick={() => this.onDeleteUploadedFile(docIdx, legIdx, childIdx)}/>
                                               </div>
                                               )}
                                            </div>
                                        }
                                        {/* {<Truck className="wt-40 ht-40 curP ml-10" onClick={() => this.setTransport(legIdx, childIdx, childleg.providerType)}/>} */}
                                        </div>
                                    }
                                </Fragment>))
                            }

                            {transportLeg === legIdx && transportChild === childIdx && <Overlay>
                                <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                                    <Heading 
                                        // text={childleg.providerName} 
                                        text={this.getProviderName(childleg.providerType)}
                                        className="tCenter"/>
                                    <CancelIcon onClick={this.setTransport} className="wt-15 ht-10 fBold theme-fill pa curP mt-10 t-0 r-0 mr-5" />
                                </div>
                                <div className="flex pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto max-wt-900 min-wt-250 max-ht-700">
                                    {transporters.map(transGroup => (
                                        <div className="mr-10 wt-250">
                                            <GroupContainer
                                            group={transGroup}
                                            toggleAllTransporters={this.toggleAllTransporters.bind(this, transGroup, legIdx, childIdx)}
                                            toggleTransporter={this.toggleTransporter.bind(this, legIdx, childIdx)}
                                            selectedTransporters={childleg.transporters}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="z-100 box-shadow pl-40 pv-10 pf b-0 col-1 bg-white">
                                <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.setTransport}>Save</button>
                                    <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.setTransport}>Cancel</button>
                                </div>
                            </Overlay>}
                            {childleg.transporters.length > 0 && 
                            <div className="pb-5 box-shadow mr-10">
                                <div className="bg-theme-light pv-10 fs-16 fSemibold mt-10 mb-10 tCenter">
                                    {/* {childleg.providerName}  */}
                                    {this.getProviderName(childleg.providerType)}
                                </div>
                                {childleg.transporters.map(transGroup => (
                                    (transGroup.transporters || []).map(transporter => (
                                        <div className="fSemibold fs-16 mb-10 col-4 inBlock pb-10 border-bottom-light-2 tCenter">{transporter.name}</div>
                                    ))
                                ))}
                            </div>}
                        </Fragment>
                        </div>
                    ))
                }  
                
                </div> 
                {leg.legType && !this.props.isEdit && leg.legName !== "Yard To Yard (BCN)" && <div className={'mt-10 tCenter'}>
                    <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20" onClick={() => this.addChild(legIdx)}>Add Type</button>
                </div>}

                </div>)})}

                {isError && <div className={'mt-10 mb-10 tCenter fs-14 error-color fBold'}>
                    {'Please enter all the highlighted feild details'}
                </div>}

                <div className={'mt-10 mb-40 tCenter'}>
                    {!this.props.isEdit && <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={this.addLeg}>Add Leg</button>}
                    {/* <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20" onClick={this.addChild}>Add Child</button> */}
                    <button className={Cx("b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20", {
                        // 'notselectable': !this.buttonValidation()
                     })} onClick={this.addTrip}>{this.props.isEdit ? 'Update' : 'Save'}</button>
                    <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20" onClick={this.onCancelAddTrip}>Cancel</button>
                </div>
                {isConfirm && <Confirmation
                    text ={"Are You Sure?"} 
                    onConfirm={this.onConfirm}
                    onCancel={this.onCancel}
                />}
                {isRouteConfirmation && 
                <Confirmation
                    text ={message}
                    onConfirm={this.onContractConfirm}
                    onCancel={this.onContractCancel}
                />}
                {selectedLeg && 
                    <Overlay>
                        <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                            <Heading 
                                text={'Providers'} 
                                className="tCenter"/>
                            <CancelIcon onClick={() => {
                                this.setState({ selectedLeg: '' })
                            }} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" />
                        </div>
                        <div className="pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto min-wt-250 max-wt-900 max-ht-700">
                            {
                                (((this.legTypes || []).find(leg => leg.name === (selectedLeg.value || {}).name) || []).childs || []).map((child, index)=> {
                                    return (
                                        <div key={index} className="pv-5 fs-16 fSemibold  flex pl-40 flex-between">
                                            <Checkbox type='square' id={"child_" + child.name + "-" + index } onCheck={()=> {
                                                // this.props.toggleTransporter(transporter, group);
                                                const findChild = selectedChilds.findIndex(el => el === child.name);
                                                if(findChild > -1) {
                                                    selectedChilds.splice(findChild, 1);
                                                } else {
                                                    selectedChilds.push(child.name)
                                                }
                                                this.setState({ selectedChilds });
                                            }}
                                            checked={selectedChilds.includes(child.name)}
                                            />
                                            <label className="wt-87p mr-10">
                                                {child.name}
                                            </label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="z-100 box-shadow pl-30 pv-10 pf b-0 col-1 bg-white flex">
                            <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20 fRight" onClick={() => this.setState({ selectedLeg: ''})}>Cancel</button>
                            <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20 fRight" onClick={() => this.onSelect((selectedLeg.value || {}).value, 'legType', selectedLeg.legIdx, (selectedLeg.value || {}).name)}>Save</button>
                        </div>
                    </Overlay>
                }
            </div>
        )
    }
}

const mapStateToProps = ({ constants }) => {
    return {
        yardLocations: constants.yardLocations || [],
        selectedNavBranch: constants.selectedNavBranch || {},
    }
}

export default connect(mapStateToProps)(AWLMUltiModeAddTrip);
